//以旧换新管理相关 api
import request from "@/utils/request";
const baseService = "autoapp-default-server-recovery";

//获取【产品类型】下拉列表
export function getProductType() {
  return request({
    url: `/autoapp-default-server-recovery/api/tbl-splb-dalei/getTblSplbDalei?flag=1&spid=&spno=`,
    method: "get"
  });
}

/**
 * @function  获取省份
 * @property {object}  data - 请求参数.
 * @returns {Promise<object>}
 */
export function findAllProvince(data) {
  return request({
    url: `${baseService}/api/tbl-recycel-engineer/province`,
    method: "post",
    data
  });
}
/**
 * @function  获取城市
 * @property {object}  provinceCode - 请求参数.
 * @returns {Promise<object>}
 */
export function findAllCity(provinceCode) {
  return request({
    url: `${baseService}/api/tbl-recycel-engineer/city?provinceCode=${provinceCode}`,
    method: "get"

  });
}
/**
 * @function  获取区域
 * @property {object}  cityCode - 请求参数.
 * @returns {Promise<object>}
 */
export function findAllDistrict(cityCode) {
  return request({
    url: `${baseService}/api/tbl-recycel-engineer/district?cityCode=${cityCode}`,
    method: "get"
  });
}

/**
 * @function  创建回收人员
 * @property {object}  data - 请求参数.
 * @returns {Promise<object>}
 */

export function addEngineer(data) {
  return request({
    url: `${baseService}/api/tbl-recycel-engineer/save`,
    method: "post",
    data
  });
}

/**
 * @function  审批回收人员
 * @property {object}  data - 请求参数.
 * @returns {Promise<object>}
 */

export function approveEngineer(data) {
  return request({
    url: `${baseService}/api/tbl-recycel-engineer/approve`,
    method: "post",
    data
  });
}




// WEBPACK FOOTER //
// ./src/api/masterFile.js